// extracted by mini-css-extract-plugin
export default {"fallback":"Kvf0t"};